const UNIT_PRICE_DECIMALS = 6;
export const UNIT_PRICE_RESIDUAL_EPS = 1e-6;

export const PRICE_CALC_MODE = {
  FROM_TOTAL: 'FROM_TOTAL',
  FROM_UNIT_PRICE: 'FROM_UNIT_PRICE',
};

export const PRICE_CALC_MODE_OPTIONS = [
  {
    value: PRICE_CALC_MODE.FROM_UNIT_PRICE,
    label: '單價計算',
  },
  {
    value: PRICE_CALC_MODE.FROM_TOTAL,
    label: '輸入總額，自動算出單價',
  },
];

/**
 * 回算單價用：四捨五入至最多 `decimals` 位。
 */
export function roundUnitPrice(value, decimals = UNIT_PRICE_DECIMALS) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const factor = 10 ** decimals;
  return Math.round(n * factor) / factor;
}

/**
 * unitPrice = total / qty；residual = |total − unitPrice×qty|。
 * qty≤0 或非法數字時回傳 null。
 */
export function calcUnitPriceFromTotal(totalPrice, qty) {
  const total = Number(totalPrice);
  const q = Number(qty);
  if (!Number.isFinite(total) || !Number.isFinite(q) || q <= 0) {
    return { unitPrice: null, residual: null };
  }

  const unitPrice = roundUnitPrice(total / q);
  if (unitPrice == null) {
    return { unitPrice: null, residual: null };
  }

  const rawResidual = Math.abs(total - unitPrice * q);
  const residual = rawResidual < UNIT_PRICE_RESIDUAL_EPS ? 0 : rawResidual;

  return { unitPrice, residual };
}

/**
 * 依計算方式寫入／預覽 line 單位單價（非 base）。
 * 模式1：total／Σqty。
 * 模式2：priceInput 即為該 line 單位價（不再／rate）。
 */
export function calcLineUnitPrice({
  priceCalcMode,
  priceTotal,
  priceInput,
  packages = [],
} = {}) {
  if (priceCalcMode === PRICE_CALC_MODE.FROM_TOTAL) {
    const qtySum = (packages ?? []).reduce(
      (sum, pkg) => sum + (Number(pkg?.qty) || 0),
      0,
    );
    return calcUnitPriceFromTotal(priceTotal, qtySum);
  }

  if (priceCalcMode === PRICE_CALC_MODE.FROM_UNIT_PRICE) {
    if (priceInput === '' || priceInput == null) {
      return { unitPrice: null, residual: null };
    }
    const unitPrice = roundUnitPrice(priceInput);
    if (unitPrice == null) {
      return { unitPrice: null, residual: null };
    }
    return { unitPrice, residual: null };
  }

  return { unitPrice: null, residual: null };
}

/** @deprecated 改用 calcLineUnitPrice */
export function calcLineBaseUnitPrice(args) {
  return calcLineUnitPrice(args);
}

export function formatUnitPriceResidual(residual) {
  const n = Number(residual);
  if (!Number.isFinite(n) || n <= 0) {
    return '0';
  }
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });
}
